import './FabItem.9bfb4db23387973f8451a14d2c77b6e1.css';
export default {"fabItem":"_fabItem_7vcja_1","wrapper":"_wrapper_7vcja_1","text":"_text_7vcja_1"};